import type { AdvancedContentSearchResponse } from "./interfaces/AdvancedContentSearchResponse";
import type { WideContentBannerData } from "../../types/wideContentBanner";
import {
  ContentType,
  ConsumeType,
  FavouriteType,
  Genre,
  Region,
} from "../../constants/enums";

/**
 * Mock данные для расширенного поиска контента
 */
const MOCK_CONTENT_ITEMS: WideContentBannerData[] = [
  {
    // Content info
    id: "mov-4398",
    title: "Властелин колец: Братство кольца",
    originalName: "The Lord of the Rings: The Fellowship of the Ring",
    releaseDate: "2001-12-19",
    certificate: "PG-13",
    length: 178,
    genres: Genre.FANTASY | Genre.ADVENTURE | Genre.ACTION,
    countryIds: [Region.UNITED_STATES, Region.NEW_ZEALAND],
    imageUrl: "https://image.tmdb.org/t/p/w500/6oom5QYQ2yQTMJIbnvbkBL9cHo6.jpg",
    typeId: ContentType.MOVIE,
    // Content statistics
    contentAverageRating: 8.8,
    contentFavouriteCount: 450000,
    contentConsumeCount: 1250000,
    // User content data
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-4399",
    title: "Властелин колец: Две крепости",
    originalName: "The Lord of the Rings: The Two Towers",
    releaseDate: "2002-12-18",
    certificate: "PG-13",
    length: 179,
    genres: Genre.FANTASY | Genre.ADVENTURE | Genre.ACTION,
    countryIds: [Region.UNITED_STATES, Region.NEW_ZEALAND],
    imageUrl: "https://image.tmdb.org/t/p/w500/5VTN0pR8gcqV3EPUHHfMGnJYN9L.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.7,
    contentFavouriteCount: 420000,
    contentConsumeCount: 1150000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-4400",
    title: "Властелин колец: Возвращение короля",
    originalName: "The Lord of the Rings: The Return of the King",
    releaseDate: "2003-12-17",
    certificate: "PG-13",
    length: 201,
    genres: Genre.FANTASY | Genre.ADVENTURE | Genre.ACTION,
    countryIds: [Region.UNITED_STATES, Region.NEW_ZEALAND],
    imageUrl: "https://image.tmdb.org/t/p/w500/rCzpDGLbOoPwLjy3OAm5NUPOTrC.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.9,
    contentFavouriteCount: 480000,
    contentConsumeCount: 1300000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-5501",
    title: "Гарри Поттер и философский камень",
    originalName: "Harry Potter and the Philosopher's Stone",
    releaseDate: "2001-11-16",
    certificate: "PG",
    length: 152,
    genres: Genre.FANTASY | Genre.ADVENTURE | Genre.FAMILY,
    countryIds: [Region.UNITED_KINGDOM, Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/wuMc08IPKEatf9rnMNXvIDxqP4W.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 7.6,
    contentFavouriteCount: 380000,
    contentConsumeCount: 950000,
    userContentRating: 8,
    userContentConsumeTypeId: ConsumeType.WATCHED,
  },
  {
    id: "ser-7823",
    title: "Игра престолов",
    originalName: "Game of Thrones",
    releaseDate: "2011-04-17",
    certificate: "TV-MA",
    length: 57,
    genres: Genre.FANTASY | Genre.DRAMA | Genre.ADVENTURE,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/u3bZgnGQ9T01sWNhyveQz0wH0Hl.jpg",
    typeId: ContentType.TV_SHOW,
    contentAverageRating: 9.2,
    contentFavouriteCount: 620000,
    contentConsumeCount: 1850000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHING,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "ser-8934",
    title: "Ведьмак",
    originalName: "The Witcher",
    releaseDate: "2019-12-20",
    certificate: "TV-MA",
    length: 60,
    genres: Genre.FANTASY | Genre.ACTION | Genre.ADVENTURE,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/7vjaCdMw15FEbXyLQTVa04URsPm.jpg",
    typeId: ContentType.TV_SHOW,
    contentAverageRating: 8.0,
    contentFavouriteCount: 280000,
    contentConsumeCount: 750000,
    userContentRating: 7,
    userContentConsumeTypeId: ConsumeType.WATCHED,
  },
  {
    id: "mov-6712",
    title: "Хоббит: Нежданное путешествие",
    originalName: "The Hobbit: An Unexpected Journey",
    releaseDate: "2012-12-14",
    certificate: "PG-13",
    length: 169,
    genres: Genre.FANTASY | Genre.ADVENTURE,
    countryIds: [Region.UNITED_STATES, Region.NEW_ZEALAND],
    imageUrl: "https://image.tmdb.org/t/p/w500/yHA9Fc37VmpUA5UncTxxo3rTGVA.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 7.8,
    contentFavouriteCount: 320000,
    contentConsumeCount: 890000,
    userContentRating: 8,
    userContentConsumeTypeId: ConsumeType.WATCHED,
  },
  {
    id: "mov-8821",
    title: "Интерстеллар",
    originalName: "Interstellar",
    releaseDate: "2014-11-07",
    certificate: "PG-13",
    length: 169,
    genres: Genre.SCI_FI | Genre.DRAMA | Genre.ADVENTURE,
    countryIds: [Region.UNITED_STATES, Region.UNITED_KINGDOM],
    imageUrl: "https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.6,
    contentFavouriteCount: 510000,
    contentConsumeCount: 1420000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-9932",
    title: "Начало",
    originalName: "Inception",
    releaseDate: "2010-07-16",
    certificate: "PG-13",
    length: 148,
    genres: Genre.SCI_FI | Genre.ACTION | Genre.THRILLER,
    countryIds: [Region.UNITED_STATES, Region.UNITED_KINGDOM],
    imageUrl: "https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.8,
    contentFavouriteCount: 580000,
    contentConsumeCount: 1650000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "ser-1123",
    title: "Очень странные дела",
    originalName: "Stranger Things",
    releaseDate: "2016-07-15",
    certificate: "TV-14",
    length: 51,
    genres: Genre.SCI_FI | Genre.HORROR | Genre.DRAMA,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/x2LSRK2Cm7MZhjluni1msVJ3wDF.jpg",
    typeId: ContentType.TV_SHOW,
    contentAverageRating: 8.7,
    contentFavouriteCount: 440000,
    contentConsumeCount: 1280000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "game-2234",
    title: "The Witcher 3: Wild Hunt",
    originalName: "The Witcher 3: Wild Hunt",
    releaseDate: "2015-05-19",
    certificate: "M",
    length: 0,
    genres: Genre.FANTASY | Genre.ACTION,
    countryIds: [Region.POLAND],
    imageUrl: "https://image.igdb.com/igdb/image/upload/t_cover_big/co1wyy.jpg",
    typeId: ContentType.GAME,
    contentAverageRating: 9.3,
    contentFavouriteCount: 390000,
    contentConsumeCount: 820000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "game-3345",
    title: "Elden Ring",
    originalName: "Elden Ring",
    releaseDate: "2022-02-25",
    certificate: "M",
    length: 0,
    genres: Genre.FANTASY | Genre.ACTION,
    countryIds: [Region.JAPAN],
    imageUrl: "https://image.igdb.com/igdb/image/upload/t_cover_big/co4jni.jpg",
    typeId: ContentType.GAME,
    contentAverageRating: 9.1,
    contentFavouriteCount: 310000,
    contentConsumeCount: 680000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHING,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "book-4456",
    title: "Властелин колец",
    originalName: "The Lord of the Rings",
    releaseDate: "1954-07-29",
    certificate: "",
    length: 0,
    genres: Genre.FANTASY | Genre.ADVENTURE,
    countryIds: [Region.UNITED_KINGDOM],
    imageUrl: "https://covers.openlibrary.org/b/id/8739161-L.jpg",
    typeId: ContentType.BOOK,
    contentAverageRating: 9.0,
    contentFavouriteCount: 520000,
    contentConsumeCount: 1100000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "book-5567",
    title: "Гарри Поттер и философский камень",
    originalName: "Harry Potter and the Philosopher's Stone",
    releaseDate: "1997-06-26",
    certificate: "",
    length: 0,
    genres: Genre.FANTASY | Genre.ADVENTURE | Genre.FAMILY,
    countryIds: [Region.UNITED_KINGDOM],
    imageUrl: "https://covers.openlibrary.org/b/id/10521270-L.jpg",
    typeId: ContentType.BOOK,
    contentAverageRating: 8.4,
    contentFavouriteCount: 480000,
    contentConsumeCount: 1320000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
  },
  {
    id: "mov-7788",
    title: "Матрица",
    originalName: "The Matrix",
    releaseDate: "1999-03-31",
    certificate: "R",
    length: 136,
    genres: Genre.SCI_FI | Genre.ACTION,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/f89U3ADr1oiB1s9GkdPOEpXUk5H.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.7,
    contentFavouriteCount: 540000,
    contentConsumeCount: 1580000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-8899",
    title: "Темный рыцарь",
    originalName: "The Dark Knight",
    releaseDate: "2008-07-18",
    certificate: "PG-13",
    length: 152,
    genres: Genre.ACTION | Genre.CRIME | Genre.DRAMA,
    countryIds: [Region.UNITED_STATES, Region.UNITED_KINGDOM],
    imageUrl: "https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 9.0,
    contentFavouriteCount: 620000,
    contentConsumeCount: 1720000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "ser-9910",
    title: "Во все тяжкие",
    originalName: "Breaking Bad",
    releaseDate: "2008-01-20",
    certificate: "TV-MA",
    length: 47,
    genres: Genre.DRAMA | Genre.CRIME | Genre.THRILLER,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/ggFHVNu6YYI5L9pCfOacjizRGt.jpg",
    typeId: ContentType.TV_SHOW,
    contentAverageRating: 9.5,
    contentFavouriteCount: 680000,
    contentConsumeCount: 1890000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "mov-1011",
    title: "Список Шиндлера",
    originalName: "Schindler's List",
    releaseDate: "1993-12-15",
    certificate: "R",
    length: 195,
    genres: Genre.DRAMA | Genre.HISTORY | Genre.WAR,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/sF1U4EUQS8YHUYjNl3pMGNIQyr0.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.9,
    contentFavouriteCount: 410000,
    contentConsumeCount: 920000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
  },
  {
    id: "mov-1112",
    title: "Форрест Гамп",
    originalName: "Forrest Gump",
    releaseDate: "1994-07-06",
    certificate: "PG-13",
    length: 142,
    genres: Genre.DRAMA | Genre.ROMANCE | Genre.COMEDY,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.tmdb.org/t/p/w500/saHP97rTPS5eLmrLQEcANmKrsFl.jpg",
    typeId: ContentType.MOVIE,
    contentAverageRating: 8.8,
    contentFavouriteCount: 550000,
    contentConsumeCount: 1640000,
    userContentRating: 9,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
  {
    id: "game-1213",
    title: "Red Dead Redemption 2",
    originalName: "Red Dead Redemption 2",
    releaseDate: "2018-10-26",
    certificate: "M",
    length: 0,
    genres: Genre.ACTION | Genre.ADVENTURE | Genre.WESTERN,
    countryIds: [Region.UNITED_STATES],
    imageUrl: "https://image.igdb.com/igdb/image/upload/t_cover_big/co1q1f.jpg",
    typeId: ContentType.GAME,
    contentAverageRating: 9.2,
    contentFavouriteCount: 420000,
    contentConsumeCount: 890000,
    userContentRating: 10,
    userContentConsumeTypeId: ConsumeType.WATCHED,
    userContentFavouriteTypeId: FavouriteType.IS_FAVOURITE,
  },
];

/**
 * Получить mock данные для расширенного поиска контента с пагинацией
 */
export function getMockAdvancedContentSearch(
  page: number = 1,
  pageSize: number = 10,
): AdvancedContentSearchResponse {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const paginatedItems = MOCK_CONTENT_ITEMS.slice(start, end);

  return {
    items: paginatedItems,
    pagination: {
      page,
      pageSize,
      total: MOCK_CONTENT_ITEMS.length,
      totalPages: Math.ceil(MOCK_CONTENT_ITEMS.length / pageSize),
    },
  };
}

/**
 * Получить все mock элементы контента (для тестирования)
 */
export function getAllMockContentItems(): WideContentBannerData[] {
  return [...MOCK_CONTENT_ITEMS];
}
